export function isValidReturnUrl(returnUrl: string): boolean {
  try {
    const url = new URL(returnUrl);

    // Must use HTTPS
    if (url.protocol !== 'https:') return false;

    // Must use port 7000
    if (url.port !== '7000') return false;

    // Hostname must be either 'localhost' or start with 'rf'
    const validHostRegex = /^(localhost|rf.*)$/i;
    if (!validHostRegex.test(url.hostname)) return false;

    return true;
  } 
  catch
  {
    return false;
  }
}
